import { render } from "./AdminPackageEdit.vue?vue&type=template&id=721d847d&scoped=true&ts=true&lang=true"
import script from "./AdminPackageEdit.vue?vue&type=script&lang=ts"
export * from "./AdminPackageEdit.vue?vue&type=script&lang=ts"

import "./AdminPackageEdit.vue?vue&type=style&index=0&id=721d847d&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721d847d"]])

export default __exports__